import React from 'react';
import styled from 'styled-components';

// Main container
const Container = styled.section`
  background-color: #f9f9f9;
  padding: 100px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 80px 20px;
  }
`;

// Title
const Title = styled.h2`
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 60px;
  color: #1a1a1a;

  @media (max-width: 768px) {
    font-size: 36px;
    margin-bottom: 50px;
  }
`;

// Responsive grid
const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 40px;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

// Card
const UserCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-12px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  }
`;

// Image
const ImageWrapper = styled.div`
  height: 280px;
  overflow: hidden;
`;

const UserImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${UserCard}:hover & {
    transform: scale(1.08);
  }
`;

// Content inside card
const Content = styled.div`
  padding: 32px;
  text-align: left;

  @media (max-width: 480px) {
    padding: 24px;
  }
`;

const UserName = styled.h3`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #111;
`;

const Description = styled.p`
  font-size: 16.5px;
  line-height: 1.7;
  color: #555;
  margin-bottom: 24px;
`;

// Learn more link with arrow
const LearnMore = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #0066ff;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: #0052cc;
    gap: 12px;
  }

  &::after {
    content: '→';
    font-size: 18px;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: translateX(4px);
  }
`;

// Component
const PlatformUsers = () => {
  const users = [
    {
      name: 'Agents',
      description:
        'Collaborate seamlessly with clients and teams. Ensure every detail — from property staging to final walkthroughs — aligns perfectly with expectations.',
      imageUrl: 'https://images.unsplash.com/photo-1558898268-92ae44e7670e?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Professional agent
      link: '/agents',
    },
    {
      name: 'Brokers',
      description:
        'Streamline deal coordination, approvals, and communication. Eliminate delays from scattered emails and keep every stakeholder aligned in real time.',
      imageUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80', // Professional in meeting
      link: '/brokers',
    },
    {
      name: 'Bancassurance',
      description:
        'Get instant visual feedback on properties and documentation. Pin issues directly on images or PDFs, assign tasks, and accelerate underwriting and compliance.',
      imageUrl: 'https://images.unsplash.com/photo-1718416303203-1477346a379c?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Banking/insurance professional
      link: '/bank-assurance',
    },
  ];

  return (
    <Container>
      <Title>Who is Nexus for?</Title>
      <UsersGrid>
        {users.map((user) => (
          <UserCard key={user.name}>
            <ImageWrapper>
              <UserImage src={user.imageUrl} alt={user.name} />
            </ImageWrapper>
            <Content>
              <UserName>{user.name}</UserName>
              <Description>{user.description}</Description>
              {/* <LearnMore href={user.link}>LEARN MORE</LearnMore> */}
            </Content>
          </UserCard>
        ))}
      </UsersGrid>
    </Container>
  );
};

export default PlatformUsers;